import template from './approve_leave_help.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class LeaveManagementHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.leave_types = ko.observableArray();
		this.holiday_types = ko.observableArray();
		this.count = ko.observable(0);
	};

	close()
	{
		this.dialog.close();
	}
};

class LeaveManagementHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new LeaveManagementHelpViewModel(this);
		this.bindings = bindings;

		let index = 0;
		this.incrementCounter = () => {
			return ++index;
		};
	};

	async init()
	{
		Utils.refresh_data_visible_roles();

		try {
			let options = {
				table: 'v_condensed_leave_types',
				schema: 'savanna',
				sortfield: 'hexcolor',
				sortorder: 'asc'
			}

			let res = await Grape.fetches.getJSON('/api/record', options);
			if (res.status == 'OK')
			{
				this.viewModel.leave_types(res.records);
				let option = {
					table: 'v_condensed_holiday_types',
					schema: 'savanna',
					sortfield: 'hexcolor',
					sortorder: 'asc'
				}

				let result = await Grape.fetches.getJSON('/api/record', option);
				if (result.status == 'OK')
					this.viewModel.holiday_types(res.records);
			}
		} catch (error)
		{
			Grape.alerts.alert({ type: 'error', title: 'Error', message: error.message });
			console.error(error)
		}
		
	};
};

export default {
	name: 'LeaveManagementHelp',
	dialog_class: LeaveManagementHelpPage,
	template: template,
	template_filename: 'translation/dialogs/approve_leave_help',
	provider: 'ps'
};
